import { Segment } from '@calendly/segment'
import { useInterval } from '@calendly/ui/hooks/use-interval'

function* trackOnce(props) {
  yield Segment.track('member_picker_not_found', props)
}

export const useTrackNotFound = (isNotFound, isAdminOrOwner) => {
  const track = trackOnce({ is_admin: isAdminOrOwner })

  useInterval(() => { track.next() }, isNotFound ? 2000 : null)
}
